import React, { useEffect, useRef, useState } from "react";

export default function Notification() {
  const [notificationData, setNotificationData] = useState();
  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      callNotificationAPI();
    }
  }, []);

  const callNotificationAPI = () => {
    const requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/notification/getMyNotificationAPI`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        // console.log(result)
        let resultdata = JSON.parse(result);
        setNotificationData(resultdata);
      })
      .catch((error) => console.error(error));
  };

  return (
    <div className="news-bar">
      <marquee>
        {notificationData?.notifications?.map((item, index)=>(
              <span key={index}>{item?.message}</span>
            ))}
      </marquee>
      <div className="icon">
        {" "}
        <img src="../images/speaker.svg" alt="" />{" "}
      </div>
    </div>
  );
}
